
import type { PerformanceCore } from './performanceCore';

/**
 * Tracks long running tasks that may block the main thread
 */
export class PerformanceLongTaskTracker {
  private core: PerformanceCore;
  
  constructor(core: PerformanceCore) {
    this.core = core;
  }
  
  trackLongTask(entry: PerformanceEntry) {
    if (entry.duration > 50) { // Only track tasks taking longer than 50ms (blocking main thread)
      this.core.trackPerformanceEvent({
        category: 'performance',
        action: 'long_task',
        label: 'browser_blocked',
        value: Math.round(entry.duration),
        metadata: {
          duration: entry.duration,
          startTime: entry.startTime
        }
      });
      
      // Also update the core metrics
      this.core.updateMetrics({
        longTasks: [{
          duration: entry.duration,
          timestamp: entry.startTime
        }]
      });
    }
  }
}
